import React, { Children, cloneElement, Component } from 'react';

import { FieldListAPI } from '@philips-emr/tws-components-api';
import { AwesomeComponent, ComponentType } from '@philips-emr/tws-core';
import { arrayOf, bool, element, eventListener, func, number, object, oneOfType, string } from '@philips-emr/tws-core/lib/component/prop-types';
import { classNames, isFunction, trigger } from '@philips-emr/tws-utils';

import { Link } from '..';
import Form from '../form/form';

import './field-list.css';

function replaceItem(origin, index, replacement) {
  const originCopy = [...origin];

  originCopy.splice(index, 1, replacement);

  return originCopy;
}

function FieldListRow(props) {
  const { children, canRemove, index, data, uuid, readOnly, onChange, onRemove } = props;

  return (
    <div className="c-field-list__row">
      <Form index={index} disabled editing={!readOnly} data={data} onChange={(e) => onChange(e, index)} uuid={uuid}>
        {Children.map(children, child => cloneElement(child, { '@repeated': true, identifier: index }))}
      </Form>

      {canRemove && !readOnly &&
      <Link className="c-field-list__remove" onClick={trigger(onRemove, index)}>tws.field-list.remove</Link>}
    </div>
  );
}

FieldListRow.propTypes = {
  canRemove: bool,
  children: oneOfType([arrayOf(element), element]),
  data: object,
  index: number,
  onChange: func,
  onRemove: func,
  readOnly: bool,
  uuid: string,
};

@AwesomeComponent({ type: ComponentType.DATA_ENTRY, api: FieldListAPI })
class FieldList extends Component {

  static propTypes = {
    children: oneOfType([arrayOf(element), element]),
    className: string,
    maxRows: number,
    onChange: eventListener,
    readOnly: bool,
    uuid: string,
    value: arrayOf(object),
  };

  static defaultProps = {
    value: [{}],
    maxRows: Infinity,
  };

  onChange = (e, index) => {
    const { value, onChange } = this.props;

    const newValue = replaceItem(value, index, e.value);

    isFunction(onChange) && onChange({
      value: newValue,
      oldValue: value,
    });
  };

  onRemove = (index) => {
    const { value, onChange } = this.props;
    const newValue = [...value];
    newValue.splice(index, 1);

    isFunction(onChange) && onChange({
      value: newValue,
      oldValue: value,
    });
  };

  onAddAnother = () => {
    const { value, onChange } = this.props;

    isFunction(onChange) && onChange({
      value: [...value, {}],
      oldValue: value,
    });
  };

  getClassName = () => {
    const { className } = this.props;

    return classNames({
      'c-field-list': true,
      [className]: Boolean(className),
    });
  };

  render() {
    const { value, uuid, children, readOnly, maxRows } = this.props;

    return (
      <div className={this.getClassName()}>
        {value.map(((row, index) => (
          <FieldListRow uuid={uuid} readOnly={readOnly} key={index} index={index} canRemove={Boolean(value.length > 1)} onChange={this.onChange} data={row} onRemove={this.onRemove}>
            {children}
          </FieldListRow>
        )))}

        {!readOnly && value.length < maxRows &&
        <Link className="c-field-list__add" onClick={this.onAddAnother}>tws.field-list.add-another</Link>}
      </div>
    );
  }
}

export default FieldList;
